export enum BlurOption {
  PREVENT_BLUR = 'PREVENT_BLUR',
  PREVENT_IMMEDIATE_CHILD_BLUR = 'PREVENT_IMMEDIATE_CHILD_BLUR',
  INSERT_TABLE = 'INSERT_TABLE',
}
